import * as React from 'react'
import { IServiceProgramObject } from '../../../types/service-program'

interface IServiceEditHeaderProps {
  serviceId: string
  name: string
  program?: IServiceProgramObject | undefined
}

const ServiceEditHeader = (props: IServiceEditHeaderProps) => {
  return (
    <div className='col-12 flex flex-row pl2 pt3 pb3 items-baseline'>
      <div className='font-blue-grey h2 bold'>Edit {props.name}</div>
      {props.program && <div className='h5 font-grey2 ml2'>Service Program: {props.program.name}</div>}
    </div>
  )
}

export default ServiceEditHeader



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditHeader.tsx